const es = {
  meta: {
    title: "Jaime Gimillo | Ingeniero Informático y Matemático",
  },
  header: {
    subtitle: "Ingeniero Informático y Matemático",
    subtitleShort: "Ing. Informático y Matemático",
    language: "Idioma",
  },
  card: {
    greeting: "Hola, soy Jaime.",
    greetingMobile: ["Hola,", "soy Jaime."],
    intro:
      "Bienvenido a una pequeña web que cuenta quién soy, qué hago y por qué. " +
      "Encontrarás también alguna cosa que he escrito y que, con suerte, podrá ayudarte.",
    bye: "Un abrazo.",
  },
  projects: {
    title: "Proyectos destacados",
    corec:
      "Una librería open-source para la implementación y evaluación de sistemas recomendadores basados en contexto.",
    smartAssure:
      "Desarrollador durante 9 meses en una herramienta basada en LLMs para la clasificación y extracción de campos de documentos.",
    adAstra:
      "Un pequeño videojuego de exploración espacial hecho con mis compañeros de carrera.",
    chatBabel:
      "Una aplicación de chat que permite a los usuarios traducir los mensajes escritos en un idioma diferente al suyo.",
  },
  contactAside: {
    title: "Contacto",
    location: "Madrid, España",
  },
  aboutMe: {
    title: "Sobre mí",
    p1:
      "El momento más feliz de la semana en el colegio eran los martes por la mañana. Había clase de TIC. " +
      "El peor sin duda, los martes por la tarde.",
    p2:
      "Acabé estudiando una carrera STEM, un doble grado en Ingeniería Informática y Matemáticas. " +
      "Posiblemente la peor, pero sobre todo la mejor, decisión que haya tomado en mi vida.",
    p3:
      "Aquí te dejo mis Trabajos Fin de Grado por si te interesa descubrir en qué me dejé varias dioptrías:",
    tfgMath: "TFG Matemáticas",
    tfgInfo: "TFG Ingeniería Informática",
    p4:
      "Ahora, estoy comenzando mi carrera profesional en el ámbito de la Inteligencia Artificial. " +
      "Esa combinación entre probabilidad y computación es lo que, para mí, la hace tan llamativa. " +
      "Estoy seguro de que en unos años, esta tecnología ya habrá transformado la manera en la que " +
      "entendemos el conocimiento y la realidad que nos rodea.",
    p5:
      "Si te interesa, abajo puedes consultar mi CV completo junto con algún dato de mi, por ahora, " +
      "breve trayectoria:",
    years: "Años",
    projects: "Proyectos",
  },
  contact: {
    title: "Hablemos",
    subtitle: "¿Tienes un proyecto? Escríbeme.",
    name: "Nombre",
    email: "Email",
    message: "Mensaje",
    send: "Enviar",
    orMail: "O envíame un correo a",
    success: "¡Gracias por contactar!",
    error: "Error al enviar: ",
  },
  blog: {
    title: "Blog personal",
    quote: "«Cuando uno enseña, dos aprenden.»",
    comingSoon: "Próximamente",
    toc: "Índice",
    onlySpanish: "Solo disponible en español por ahora",
  },
  comments: {
    title: "Comentarios",
    name: "Nombre",
    namePlaceholder: "Tu nombre",
    comment: "Comentario",
    commentPlaceholder: "Escribe tu comentario...",
    success: "¡Comentario enviado correctamente!",
    sending: "Enviando...",
    submit: "Enviar comentario",
    empty: "No hay comentarios todavía. ¡Sé el primero en comentar!",
    errorEmpty: "Por favor, rellena todos los campos.",
    errorShort: "El comentario es demasiado corto.",
    errorSend: "Error al enviar el comentario. Inténtalo de nuevo.",
    justNow: "Ahora mismo",
  },
};

export default es;
